import { render, staticRenderFns } from "./DisplayBlock.vue?vue&type=template&id=4b4d0f5e"
import script from "./DisplayBlock.vue?vue&type=script&lang=js"
export * from "./DisplayBlock.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports